const PagingComponent = {
    templateUrl: '/formViewer/component/rowRepeater/paging/paging.tpl.html',
    controller: 'pagingController',
    bindings: {
        source: '<',
        pageSize: '<',
        timeLastModified: '<',
        printPreview: '<',
        onChange: '&'
    }
};

angular.module('umFormViewer')
    .component('uiPaging', PagingComponent);
